export const Genders = [
  { value: "FE", text: 'زن' },
  { value: "MA", text: 'مرد' },



]
const GenderSetter = (val) => {

  let value = null
  Genders.forEach((el) => {
    if (el.value === val) {
      value = el.text;
    }
  })
  return value;
}
export default GenderSetter;
